'use strict';
(function () {
  if (window.VSKLOCartAddonEditor) return;

  function splitAddonText(raw) {
    return String(raw || '')
      .split(/\r?\n/)
      .map(function (line) { return line.replace(/^\s*\d+\)\s*/, '').trim(); })
      .filter(Boolean);
  }

  function composeAddonText(values) {
    return (values || [])
      .map(function (value) { return String(value || '').trim(); })
      .filter(Boolean)
      .map(function (value, index) { return (index + 1) + ') ' + value; })
      .join('\n');
  }

  function collectEditorText(editor) {
    if (!editor) return '';
    var sameCheckbox = editor.querySelector('[data-vsklo-same-text]');
    var sameField = editor.querySelector('[data-vsklo-same-text-field]');
    if (!sameCheckbox || sameCheckbox.checked) return sameField?.value?.trim() || '';

    return composeAddonText(
      Array.from(editor.querySelectorAll('[data-vsklo-text-part]')).map(function (field) {
        return field.value;
      })
    );
  }

  function autoSizeAddonTextarea(field) {
    if (!field || field.matches('[data-vsklo-addon-text]')) return;
    if (field.offsetParent === null && !field.getClientRects().length) return;

    var maxHeight = Math.max(140, Math.min(360, Math.round(window.innerHeight * 0.42)));
    field.style.height = 'auto';
    var nextHeight = Math.max(54, Math.min(maxHeight, field.scrollHeight || 54));
    field.style.height = nextHeight + 'px';
    field.style.overflowY = (field.scrollHeight || 0) > maxHeight ? 'auto' : 'hidden';
  }

  function create(options) {
    options = options || {};
    var root = options.root || document;
    var t = typeof options.t === 'function'
      ? options.t
      : function (_key, fallback) { return fallback; };

    function autoSizeAddonTextareas(scope) {
      (scope || root)
        .querySelectorAll('textarea.vsklo-addon-text:not([data-vsklo-addon-text])')
        .forEach(autoSizeAddonTextarea);
    }

    function renderAddonEditor(row, quantity, forceSameState) {
      if (!row || row.dataset.noEngraving === 'true') return;

      var editor = row.querySelector('[data-vsklo-engraving-editor]');
      if (!editor) return;

      var qtyInput = row.querySelector('[data-vsklo-qty-input]');
      var requestedQty = Math.max(
        1,
        parseInt(quantity || editor.dataset.quantity || qtyInput?.value || '1', 10) || 1
      );

      if (
        editor.dataset.rendered === '1' &&
        editor.dataset.quantity === String(requestedQty) &&
        forceSameState !== true &&
        forceSameState !== false
      ) {
        return;
      }

      var source = editor.querySelector('[data-vsklo-addon-text]');
      if (!source) {
        source = document.createElement('textarea');
        source.dataset.vskloAddonText = 'true';
      }

      var rawBefore = editor.dataset.rendered === '1'
        ? collectEditorText(editor)
        : (source.value || editor.dataset.initialText || '');

      var qty = requestedQty;
      var values = splitAddonText(rawBefore);
      var fallbackValue = rawBefore && !values.length ? rawBefore : (values[0] || '');
      var sameText = qty <= 1;

      if (qty > 1) {
        if (forceSameState === true || forceSameState === false) sameText = forceSameState;
        else if (editor.dataset.sameText) sameText = editor.dataset.sameText === 'true';
        else sameText = values.length < 2;
      }

      var serviceType = String(
        row.dataset.vskloServiceType || row.dataset.vskloServiceKind || ''
      ).toLowerCase().replace(/[\s-]+/g, '_');
      var isPostcard = serviceType === 'postcard';

      var singleTextPlaceholder = isPostcard
        ? t('postcardTextPlaceholder', 'Введіть текст листівки')
        : t('enterEngravingText', 'Введіть текст гравіювання');

      editor.dataset.rendered = '1';
      editor.dataset.quantity = String(qty);
      editor.dataset.sameText = sameText ? 'true' : 'false';
      editor.innerHTML = '';

      source.classList.add('vsklo-addon-text', 'vsklo-addon-text-source');
      source.hidden = true;
      editor.appendChild(source);

      if (qty > 1) {
        var sameLabel = document.createElement('label');
        sameLabel.className = 'vsklo-same-text-row';

        var sameCheckbox = document.createElement('input');
        sameCheckbox.type = 'checkbox';
        sameCheckbox.checked = sameText;
        sameCheckbox.dataset.vskloSameText = 'true';

        var sameSpan = document.createElement('span');
        sameSpan.textContent = t(
          'sameTextForAll',
          'Один текст для всіх ' + qty + ' шт.',
          { qty: qty }
        );

        sameLabel.appendChild(sameCheckbox);
        sameLabel.appendChild(sameSpan);
        editor.appendChild(sameLabel);
      }

      if (sameText) {
        var textarea = document.createElement('textarea');
        textarea.className = 'vsklo-addon-text';
        textarea.dataset.vskloSameTextField = 'true';
        textarea.rows = 2;
        textarea.maxLength = 200;
        textarea.placeholder = singleTextPlaceholder;
        textarea.value = fallbackValue;
        editor.appendChild(textarea);
        source.value = textarea.value.trim();
      } else {
        var baseValues = values.length ? values : (fallbackValue ? [fallbackValue] : []);
        for (var index = 0; index < qty; index += 1) {
          var field = document.createElement('textarea');
          field.className = 'vsklo-addon-text';
          field.dataset.vskloTextPart = String(index + 1);
          field.rows = 2;
          field.maxLength = 200;
          field.placeholder = isPostcard
            ? t('postcardTextNumber', 'Текст листівки #' + (index + 1), { index: index + 1 })
            : t('engravingTextNumber', 'Текст гравіювання #' + (index + 1), { index: index + 1 });
          field.value = baseValues[index] || '';
          editor.appendChild(field);
        }
        source.value = collectEditorText(editor);
      }

      requestAnimationFrame(function () {
        autoSizeAddonTextareas(row);
      });
    }

    function hydrate(scope) {
      var cartRoot = document.querySelector('#main-cart-items');
      if (!cartRoot) return;

      var candidate = scope && scope.querySelectorAll ? scope : cartRoot;
      var queryRoot =
        candidate === document ||
        candidate === document.documentElement ||
        candidate === document.body
          ? cartRoot
          : (candidate.closest?.('#main-cart-items') ||
             candidate.querySelector?.('#main-cart-items') ||
             cartRoot);

      queryRoot.querySelectorAll('[data-vsklo-addon-row]').forEach(function (row) {
        var qty =
          row.querySelector('[data-vsklo-qty-input]')?.value ||
          row.querySelector('[data-vsklo-engraving-editor]')?.dataset.quantity ||
          '1';
        renderAddonEditor(row, qty);
      });

      queryRoot.querySelectorAll('[data-vsklo-cart-addon-popup]').forEach(function (popup) {
        if (popup.classList.contains('is-active')) return;
        popup.classList.remove('is-active');
        popup.setAttribute('aria-hidden', 'true');
        popup.setAttribute('inert', '');
        popup.hidden = true;
      });

      requestAnimationFrame(function () {
        autoSizeAddonTextareas(queryRoot);
      });
    }

    return Object.freeze({
      splitAddonText: splitAddonText,
      composeAddonText: composeAddonText,
      collectEditorText: collectEditorText,
      autoSizeAddonTextarea: autoSizeAddonTextarea,
      autoSizeAddonTextareas: autoSizeAddonTextareas,
      renderAddonEditor: renderAddonEditor,
      hydrate: hydrate
    });
  }

  window.VSKLOCartAddonEditor = Object.freeze({
    create: create,
    splitAddonText: splitAddonText,
    composeAddonText: composeAddonText,
    collectEditorText: collectEditorText,
    autoSizeAddonTextarea: autoSizeAddonTextarea
  });
})();